import React, { Fragment, Component } from 'react';
import {connect} from "react-redux";
import _ from "lodash";
import Joi from "@hapi/joi";

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  UncontrolledTooltip,
  Button
} from 'reactstrap';

import BaseForm from "../BaseClass/Form";
import FormErrorWidget from "../Common/FormErrorWidget";
import ServerErrorWidget from "../Common/ServerErrorWidget";

import ProcessingModal from "../Common/ProcessingModal";

import loginLogo from '../../assets/jobelephant/images/login_logo_new.png';

//Load UI action creators and selectors
import { 
  resetPassword,
} from "../../store/auth";

import { 
  clearErrors,
  getServerErrors 
} from "../../store/ui-reset-password";
// End of loading action creators and selectors

class ResetPassword extends BaseForm {
  divAreaToScrollForError = "formArea";
  
  validationSchema = Joi.object({
    password:Joi.string().min(8).required().pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^ ]{8,}$/).label('Password'),
    retypePassword:Joi.string().required().valid(Joi.ref('password')).label('Retype Password'),
  });

  errorMessages = {
    "password":{
        "string.pattern.base":"New Password needs to be 8 characters long, must contain at least one uppercase letter, one lowercase letter and one number",
    },
    "retypePassword":{
        "any.only":"Retype Password should match the New Password"
    }
  }

  constructor(props){
    super(props);
    this.state = {
        data:{
          password:"",
          retypePassword:"",
        },
        errors:{} 
    }
  }

  

  submitLocal=()=>{
    const {clearErrors,resetPassword} = this.props;
    clearErrors();
    resetPassword({
      ...this.state.data
    })
  }

  validateLocal = ()=>{

  }

  render() {
    const {data,errors:localErrors} = this.state;
    const {processingModalDisplayFlag,errors:serverErrors} = this.props
    const {retypePassword,password} = data;

    return (
      <Fragment>
        <div className="app-wrapper min-vh-100">
          <div className="app-main min-vh-100">
            <div className="app-content p-0">
              <div className="app-content--inner d-flex align-items-center">
                <div className="flex-grow-1 w-100 d-flex align-items-center">
                  <div className="bg-composed-wrapper--content py-5">
                    <div className="container">
                      <Row>
                        <Col
                          lg="5"
                          className="d-none d-lg-flex align-items-center">
                          <img
                            alt="..."
                            className="w-100 mx-auto d-block img-fluid"
                            src={loginLogo}
                          />
                        </Col>
                        <Col
                          lg="7"
                          sm="12"
                          className=" d-flex justify-content-center align-items-center">
                          <div className="" id="formArea">
                            <div className="mt-3">
                              <div className="d-block d-lg-none mb-3">
                                <img
                                    alt="..."
                                    className="d-block d-lg-none mx-auto d-block img-fluid"
                                    src={loginLogo}
                                    style={{ width:"200px", height:"200px", }}
                                />
                              </div>
                              <span className="text-left text-sm-center">
                                <h2 className="d-none d-sm-block display-3 text-left mb-1 font-weight-bold">
                                  Reset Password
                                </h2>
                                <h2 className="d-block d-sm-none display-4 text-left mb-1 font-weight-bold">
                                  Reset Password
                                </h2>
                                <p className="text-secondary text-left mb-1">
                                  Please enter your new password:
                                </p>
                              </span>
                              <div>
                                <div id="errorArea">
                                    {/*Error display */}
                                      {   !_.isEmpty(localErrors) &&
                                          <FormErrorWidget
                                              errors={localErrors}
                                              displayFirstColumnAsSpace={false}
                                          />
                                      }

                                      {   !_.isEmpty(serverErrors) &&
                                          <ServerErrorWidget
                                              errors={serverErrors}
                                              displayAsAlert={true}
                                          />
                                      }
                                    {/* End of Error display */}
                                </div>
                                <Form onSubmit={this.submitForm}>
                                  <FormGroup>
                                    <label>New Password</label>
                                    <Input
                                      placeholder="Password"
                                      type="password"
                                      name="password"
                                      id="password"
                                      value={password}
                                      onChange={this.handleChange}
                                    />
                                  </FormGroup>
                                  <FormGroup>
                                    <label>Retype New Password</label>
                                    <Input
                                      placeholder="Retype Password"
                                      type="password"
                                      name="retypePassword"
                                      id="retypePassword"
                                      value={retypePassword}
                                      onChange={this.handleChange}
                                    />
                                  </FormGroup>
                                  

                                  <Button type="submit" size="lg" block={true} color="primary"
                                    onClick={this.submitForm} 
                                  >
                                    Submit
                                  </Button>
                                </Form>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Processing Modal */}
        <ProcessingModal
            displayModal={processingModalDisplayFlag}
            handleCloseOfModalWindow={()=>{}}
        />
        {/* Processing Modal */}
        
      </Fragment>
    );
  }
}

const mapStateToProps = state=>({
  processingModalDisplayFlag:state.auth.loading,
  errors:getServerErrors(state),
});

const mapDispatchToProps = (dispatch)=>({
  clearErrors:()=>dispatch(clearErrors()),
  resetPassword:(formData)=>dispatch(resetPassword(formData)),
});

export default connect(mapStateToProps,mapDispatchToProps)(ResetPassword);

